import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';

import { FontSizeDirective } from './font-size.directive';
import { ScrollToDirective } from './scroll-to.directive';
import { AppDropdownDirective } from './dropdown.directive';
import { DropdownAnchorDirective } from './dropdown-anchor.directive';
import { DropdownLinkDirective } from './dropdown-link.directive';
import { EgretSideNavToggleDirective } from './egret-side-nav-toggle.directive';
import {
  EgretSidenavHelperDirective,
  EgretSidenavTogglerDirective,
} from './egret-sidenav-helper/egret-sidenav-helper.directive';
import { EgretHighlightDirective } from './egret-highlight.directive';
import { FormatNumberDirective } from './format-number.directive';
import { FormatRowPipe } from '../pipes/format-row.pipe';
import { TitleCaseDirective } from './title-case.directive';
import { CapitalFirstLetterDirective } from './capital-first-letter.directive';
import { DragulaExtendedDirective } from './dragula-extended.directive';

const directives = [
  FontSizeDirective,
  ScrollToDirective,
  AppDropdownDirective,
  DropdownAnchorDirective,
  DropdownLinkDirective,
  EgretSideNavToggleDirective,
  EgretSidenavHelperDirective,
  EgretSidenavTogglerDirective,
  EgretHighlightDirective,
  FormatNumberDirective,
  TitleCaseDirective,
  CapitalFirstLetterDirective,
  DragulaExtendedDirective,
];

@NgModule({
  imports: [CommonModule],
  declarations: directives,
  exports: directives,
  providers: [FormatRowPipe, TitleCasePipe],
})
export class SharedDirectivesModule {}
